import { TrendingDown } from "lucide-react";
import { Reveal, Chapter } from "@/components/site/Reveal";
import { CHALLENGES } from "@/data/content";

export default function Challenge() {
  return (
    <section id="challenge" data-testid="challenge-section" className="bg-ivory text-slateink">
      <div className="mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-36">
        <Chapter n="Chapter 01" label="The Production Finance Challenge" />
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <h2 className="text-balance font-serif text-3xl font-medium leading-tight tracking-tight sm:text-4xl lg:text-5xl">
                Production money leaks in the dark.
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-8 max-w-md text-base leading-relaxed text-bodylight sm:text-lg">
                Film and media productions run on trust, speed and informal commitments. Traditional
                accounting arrives after the damage — recording losses, not preventing them.
              </p>
            </Reveal>
            <Reveal delay={0.25}>
              <div className="mt-10 flex items-center gap-4 border-l-2 border-gold pl-5">
                <TrendingDown className="text-gold" size={20} strokeWidth={1.5} />
                <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-bodylight">
                  Industry estimate — 8–15% of production budgets are lost to leakage
                </p>
              </div>
            </Reveal>
          </div>

          <div className="grid gap-px bg-slateink/10 sm:grid-cols-1 lg:col-span-7">
            {CHALLENGES.map((c, i) => (
              <Reveal key={c.n} delay={0.1 + i * 0.12}>
                <article
                  data-testid={`challenge-card-${i + 1}`}
                  className="group relative bg-ivory p-8 transition-colors duration-500 hover:bg-parchment sm:p-10"
                >
                  <div className="flex items-start gap-8">
                    <span className="font-serif text-4xl italic text-gold/70 transition-colors group-hover:text-gold">{c.n}</span>
                    <div>
                      <h3 className="font-serif text-xl font-semibold sm:text-2xl">{c.title}</h3>
                      <p className="mt-3 max-w-lg text-sm leading-relaxed text-bodylight sm:text-base">{c.body}</p>
                    </div>
                  </div>
                  <span className="absolute bottom-0 left-0 h-px w-0 bg-inkred transition-all duration-700 group-hover:w-full" aria-hidden="true" />
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
